<template>
    <div class="customers">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <div class="customers__text">
                        <TitleDescription
                            title="Partner Up to Boost Your Sales "
                            description="Get into a unique safe space for your business. Here you don't compete with other brands for customers."  
                        />
                    </div>
                </div>
            </div>
        </div>
        <div class="customers__picture">
            <img class="d-md-block d-none w-100" src="/img/ecommerce-landing-men.jpg" alt="">
            <img class="d-md-none d-block w-100" src="/img/ecommerce-landing-men-mob.jpg" alt="">
        </div>
    </div>
</template>

<script>
import TitleDescription from '../../../components/Ecommerce/TitleDescription'
export default {
    name: 'Customers',
    components: {
        TitleDescription
    }
}
</script>

<style lang="scss" scoped>
$background: #F4F7FA;
$text_wrapper_width: 500px;
$text_wrapper_gap: 115px;
$text_wrapper_mobile_gap: 96px;
$text_wrapper_sm_gap: 48px;

.customers {
    --title-fontsize: 28px;
    --title-lineheight: 32px;
    --title-margin-bottom: 8px;
    --description-fontsize: 18px;
    --description-lineheight: 24px;

    --title-color: #00002D;
    --description-color: #00002D;

    @media (max-width: 576px) {
        --title-fontsize: 20px;
        --title-lineheight: 28px;
        --description-fontsize: 16px;
        --description-lineheight: 24px;
    }

    background: $background;
    &__text {
        width: 100%;
        max-width: $text_wrapper_width;
        padding: $text_wrapper_gap 0;
        text-align: center;
        margin: 0 auto;
        @media (max-width: 768px) {
            padding: $text_wrapper_mobile_gap 0;
        }
        @media (max-width: 576px) {
            padding: $text_wrapper_sm_gap 0;
        }
    }
}
</style>>
